'use client';

export default function LingoCircle({ color = '#28393D' }) {
  return (
    <svg width='23' height='22' viewBox='0 0 23 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='11.3865' cy='11' r='8.5' stroke={color} strokeWidth='5' />
    </svg>
  );
}
